import React from 'react'
import { cn } from '../../utils/cn'

export interface AppBarProps {
  left?: React.ReactNode
  center?: React.ReactNode
  right?: React.ReactNode
  className?: string
  sticky?: boolean
  elevation?: boolean
  contentClassName?: string
}

export const AppBar: React.FC<AppBarProps> = ({
  left,
  center,
  right,
  className,
  sticky = true,
  elevation = true,
  contentClassName,
}) => {
  return (
    <div className={cn(sticky && 'sticky top-0 z-10', className)}>
      <div
        className={cn(
          'h-12 px-4',
          elevation && 'shadow-elevated',
        )}
        style={{
          backgroundColor: 'var(--bg-elevated)',
        }}
      >
        <div className={cn('h-12 w-full flex items-center justify-between', contentClassName)}>
          <div className="flex items-center gap-2">{left}</div>
          <div className="flex items-center">{center}</div>
          <div className="flex items-center gap-2">{right}</div>
        </div>
      </div>
    </div>
  )
}
